module.exports = __webpack_public_path__ + "./fonts/kasmlogo.4bc133ba65a7d3dfd3a53164f9d33a09.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/kasmlogo.svg
// module id = ./assets/images/kasmlogo.svg
// module chunks = 0